import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Friends from '@/components/friends/friends'
import Detail from '@/components/detail/newsdetail'
import Pcenter from '@/components/pcenter/pcenter'
import Follow from '@/components/follow/follow'
import Search from '@/components/search/search'


import Test from '@/components/test/test' //测试用

Vue.use(Router)

//解决vue报Uncaught (in promise) NavigationDuplicated个错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      children:[
        {
          path: '/',
          name: 'index',
          component: () => import('@/components/index/index'),
        },
        {
          path:'/update',
          name:'update',
          component:() => import('@/components/update/update')
        },
        {
          path:'/bbs',
          name:'gossip',
          component:() => import('@/components/gossip/gossip')
        },
        {
          path:'/friends',
          name:'friends',
          component:Friends
        }
      ]
    },
    {
      path:'/arealogin',
      name:'login',
      component:() => import('@/components/login/login')
    },
    {
      path:'/newsdetail/:tid',
      name:'newsdetail',
      component:Detail
    },
    {
      path:'/pcenter',
      name:'personcenter',
      meta:{
        needLogin:true
      },
      component:Pcenter
    },
    {
      path:'/follow',
      name:'follow',
      component:Follow
    },

    {
      path:'/search',
      name:'search',
      component:Search,
     
    },
    {
      path:'/test',
      name:'test',
      component:Test
    },
    {
      path: '/home',
      name: 'home',
      mata:{title:'',role:'ishouse'},
      redirect:'/home',
      component: () => import( '../components/house/index.vue'),
      children:[
        {
          path: '/home',
          name: 'home',
          meta:{title:'首页',role:'ishouse'},
          component: () => import( '../components/house/house'),
        },
        {
          path: '/esf',
          name: 'esf',
          meta:{title:'二手房',role:'ishouse'},
          component: () => import( '../components/house/house/hands'),
        },
        {
          path: '/zf',
          name: 'zf',
          meta:{title:'租房',role:'ishouse'},
          component: () => import( '../components/house/house/zf'),
        },
        {
          path: '/sp',
          name: 'sp',
          meta:{title:'商铺',role:'ishouse'},
          component: () => import( '../components/house/house/sp'),
        },
        {
          path: '/xzl',
          name: 'xzl',
          meta:{title:'写字楼',role:'ishouse'},
          component: () => import( '../components/house/house/xzl'),
        },
        {
          path: '/agent',
          name: 'jjr',
          meta:{title:'找经纪人',role:'ishouse'},
          component: () => import( '../components/house/house/agent'),
        },
        {
          path: '/agent/agenthome',
          name: 'jjr',
          meta:{title:'找经纪人',role:'ishouse'},
          component: () => import( '../components/house/house/agenthome'),
        },
        {
          path: '/office',
          name: 'office',
          meta:{title:'求租求购',role:'ishouse'},
          component: () => import( '../components/house/house/office'),
        },
        {
          path: '/esf/detail',
          name: 'esf',
          meta:{title:'二手房',role:'ishouse'},
          component: () => import( '../components/house/house/detail'),
        },
        {
          path: '/zf/detail',
          name: 'zf',
          meta:{title:'租房',role:'ishouse'},
          component: () => import( '../components/house/house/detail'),
        },
        {
          path: '/xzl/detail',
          name: 'xzl',
          meta:{title:'写字楼',role:'ishouse'},
          component: () => import( '../components/house/house/detail'),
        },
        {
          path: '/sp/detail',
          name: 'sp',
          meta:{title:'商铺',role:'ishouse'},
          component: () => import( '../components/house/house/detail'),
        },
        {
          path: '/office/detail',
          name: 'askdetail',
          meta:{title:'求租求购',role:'ishouse'},
          component: () => import( '../components/house/house/askdetail'),
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js